import { createAction, handleActions } from 'redux-actions'

/***
 * Common Actions
 *
 * The following actions are globally recognized by one or more subreducers.
 */
export const RESET_GAME = 'BPF_4075/RESET_GAME'
export const resetGame = createAction(RESET_GAME)

export const OPEN_QUIZ_MODAL = 'BPF_4075/quizzes/OPEN_QUIZ_MODAL'
export const SUBMIT_QUIZ_ANSWER = 'BPF_4075/quizzes/SUBMIT_QUIZ_ANSWER'
export const CLOSE_QUIZ_MODAL = 'BPF_4075/quizzes/CLOSE_QUIZ_MODAL'

const initialState = {
  clearedQuizRoomIds: [],
  isActive: false,
  question: undefined,
  answer: undefined,
  options: {},
}

export default handleActions(
  {
    [RESET_GAME]: () => ({ ...initialState }),

    [OPEN_QUIZ_MODAL]: (state, { payload }) => ({
      ...state,
      isActive: true,
      question: payload.question,
      answer: payload.answer,
      options: payload.options,
    }),

    [SUBMIT_QUIZ_ANSWER]: (state, { payload }) => ({
      ...state,
      clearedQuizRoomIds: [...state.clearedQuizRoomIds, payload.roomId],
    }),

    [CLOSE_QUIZ_MODAL]: (state) => ({
      ...state,
      isActive: false,
      question: undefined,
      answer: undefined,
      options: {},
    }),
  },
  initialState,
)

export const openQuizModal = createAction(OPEN_QUIZ_MODAL)
export const submitQuizAnswer = createAction(SUBMIT_QUIZ_ANSWER)
export const closeQuizModal = createAction(CLOSE_QUIZ_MODAL)



// WEBPACK FOOTER //
// ./src/modules/quizzes.js